import { render } from "./InventoryDetailsModal.vue?vue&type=template&id=790bd943&scoped=true"
import script from "./InventoryDetailsModal.vue?vue&type=script&lang=js"
export * from "./InventoryDetailsModal.vue?vue&type=script&lang=js"

import "./InventoryDetailsModal.vue?vue&type=style&index=0&id=790bd943&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790bd943"]])

export default __exports__